import React from 'react'

export function StartZertifikat({pictureName}) {

    return <div className="col-12 md:col-12 lg:col-4" style={{padding: 10}}>
        <div className="kachelStartseite" style={{height: "100%"}}>
            <img src={"/images/" + pictureName} style={{width:"100%"}} alt="Chrome"/>
        </div>
    </div>
}
